/**
 * 원본: .old-gc-mono/apps/gc-zoku/components/pages/GrantAnalyticsGuide.js
 * GA 권한 부여 실패 시 안내 페이지
 */
function GrantAnalyticsGuide() {
  return (
    <div style={{ padding: 30, flex: 1, background: '#f0f2f5' }}>
      <p style={{ fontWeight: 'bold', color: 'red' }}>
        Failed to grant access. Please retry by following these steps:
      </p>
      <ul style={{ lineHeight: 2 }}>
        <li>Log in your YouTube account on this browser.</li>
        <li>
          Access{' '}
          <a
            href="https://security.google.com/settings/security/permissions"
            target="_blank"
            rel="noopener noreferrer"
          >
            this link
          </a>
        </li>
        <li>
          Find &quot;GGContent&quot; and click &quot;REMOVE ACCESS&quot;
          <br />
          <img
            src="/assets/images/GrantAnalyticsGuide/01.png"
            alt="Remove access guide"
            style={{ marginTop: 10, marginBottom: 10, maxWidth: '100%' }}
          />
        </li>
        <li>Try again (Sign in, Grant analytics, etc).</li>
      </ul>
    </div>
  );
}

export default GrantAnalyticsGuide;
